// Pick out properties that are common to both Email & SMS

export const SMS_STATE = {
  AUTOMATED_DRAFT: 'AUTOMATED_DRAFT',
  DRAFT: 'DRAFT',
  ERROR: 'ERROR',
  PRE_PROCESSING: 'PRE_PROCESSING',
  PROCESSING: 'PROCESSING',
  PUBLISHED: 'PUBLISHED',
  SCHEDULED: 'SCHEDULED',
  AUTOMATED: 'AUTOMATED'
};
export const SMS_PUBLISH_STATUS = {
  DRAFT: 'DRAFT',
  SCHEDULED: 'SCHEDULED',
  PUBLISHED: 'PUBLISHED'
};
export const SMS_TYPE = {
  AUTOMATED: 'AUTOMATED',
  BATCH: 'BATCH',
  AUTOMATED_AB: 'AUTOMATED_AB',
  BATCH_AB: 'BATCH_AB',
  LOCALTIME: 'LOCALTIME'
};
export const SMS_SUBCATEGORY = {
  AUTOMATED: 'automated',
  BATCH: 'batch',
  LOCALTIME: 'localtime'
};